import { render, staticRenderFns } from "./vc-slider.vue?vue&type=template&id=625c7080&scoped=true&"
import script from "./vc-slider.vue?vue&type=script&lang=js&"
export * from "./vc-slider.vue?vue&type=script&lang=js&"
import style0 from "./vc-slider.vue?vue&type=style&index=0&id=625c7080&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625c7080",
  null
  
)

export default component.exports